import React, { useContext, useEffect, useState } from 'react'
import TimeLineTarget from '../../TimeLine/TimeLineTarget';
import { AnalisisComentariosLine } from '../../AnalisisComentariosLine';
import { AnalisisCreditoContext } from '../../AnalisisCreditoScreen';
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { LoaderScreen } from '../../../components/LoaderScreen';
import { ModalSolicitudCredito } from '../../Modales/ModalSolicitudCredito';
import MdlSolicitudCreditoScreen from '../../Modales/MdlSolicitudCreditoScreen';
import MdlAnalisisSolicitud from '../../Modales/MdlAnalisisSolicitud';
import MdlAnalisisOtorgamientoCredito from '../../Modales/MdlAnalisisOtorgamientoCredito';
import MdlDictamen from '../../Modales/MdlDictamen';
import ComputerIcon from "@mui/icons-material/Computer";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FactCheckIcon from "@mui/icons-material/FactCheck";

export const Excedente = ({ data, estado, upload, direccion }) => {
  const { state } = useContext(AnalisisCreditoContext);
  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [comentarios, setComentario] = useState([]);
  const [value, setValue] = useState(0);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    onActualizarComentarios();
  }, []);

  const onActualizarComentarios = () => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setComentario(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITU", JSON.stringify(error), "error");
      });
  };
  return (
    <PlantillaScreen
      titulo={"PROCESO DE SOLICITUD DE CREDITO DE LINEA POR OPERACION"}
      className={"analisis-sc-procesos"}
    >
      <LoaderScreen loader={loader} />
      <ModalSolicitudCredito
        open={openSolicitud}
        setOpenSolicitud={setOpenSolicitud}
        value={value}
        setValue={setValue}
        upload={upload}
        maxValue={Number(estado.pantallacompleta)}
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <MdlAnalisisSolicitud
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen2: (
            <MdlAnalisisOtorgamientoCredito
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen3: (
            <MdlDictamen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          )
        }}
        titulos={{
          screen0: "SOLICITUD DE CREDITO",
          screen1: "ANALIZAR DE SOLICITUD DE CREDITO",
          screen2: "OTORGAMIENTO DE CREDITO",
          screen3: "DICTAMEN"
        }}
      />
      <div className="analisis-sc-procesos-timeline-title ">
        {state.cliente}
      </div>
      <div className="analisis-sc-procesos-timeline scroll-4">
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Genero Solicitud"}
          subtitle={"Vendedor"}
          footer={{
            tiempoestimado: data[0].estado,
            leyenda: data[0].creado,
            duracion: data[0].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[0].control}
          active={1 === Number(estado.pantallacompleta)}
          value={0}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ManageSearchIcon />}
          title={"Analizar Solicitud"}
          subtitle={"Coordinador de Crédito"}
          footer={{
            tiempoestimado: data[1].estado,
            leyenda: data[1].creado,
            duracion: data[1].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[1].control}
          active={2 === Number(estado.pantallacompleta)}
          value={1}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Otorgar Crédito"}
          subtitle={"Coordinador de Crédito"}
          footer={{
            tiempoestimado: data[2].estado,
            leyenda: data[2].creado,
            duracion: data[2].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[2].control}
          active={3 === Number(estado.pantallacompleta)}
          value={2}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<FactCheckIcon />}
          title={"Dictamen"}
          subtitle={"Coordinador de Crédito"}
          footer={{
            tiempoestimado: data[3].estado,
            leyenda: data[3].creado,
            duracion: data[3].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[3].control}
          active={4 === Number(estado.pantallacompleta)}
          value={3}
          setValue={setValue}
          endtarget={true}
        />
      </div>
      <AnalisisComentariosLine
        tiempotranscurrido={estado.tiempotranscurrido}
        tiempoestimado={estado.tiempoestimado}
        comentarios={comentarios}
      />
    </PlantillaScreen>
  );
};
